import React from 'react';
import { REVIEW_TABS, VERDICT_BUCKETS } from '../../utils/ipoReviews';

const TAB_COUNT_TONES = {
  all: 'bg-teal-100 text-[#006666]',
  mainboard: 'bg-slate-200/80 text-slate-600',
  sme: 'bg-amber-100 text-amber-700',
};

const VERDICT_TONES = {
  apply: { idle: 'border-emerald-200 bg-emerald-50 text-emerald-700 hover:bg-emerald-100', active: 'border-emerald-600 bg-emerald-600 text-white' },
  may: { idle: 'border-amber-200 bg-amber-50 text-amber-700 hover:bg-amber-100', active: 'border-amber-500 bg-amber-500 text-white' },
  avoid: { idle: 'border-rose-200 bg-rose-50 text-rose-600 hover:bg-rose-100', active: 'border-rose-600 bg-rose-600 text-white' },
  awaited: { idle: 'border-slate-200 bg-slate-50 text-slate-600 hover:bg-slate-100', active: 'border-slate-700 bg-slate-700 text-white' },
};

// Board tabs plus verdict chips; clicking the active chip clears it
export const ReviewControls = ({ tab, onTabChange, tabCounts, verdict, onVerdictChange, verdictCounts }) => (
  <div className="flex flex-col lg:flex-row lg:items-center justify-between gap-3 bg-white rounded-2xl border border-slate-200/90 shadow-sm p-2.5 sm:p-3">
    <div role="group" aria-label="Board" className="inline-flex self-start gap-1 p-1 rounded-xl bg-slate-100 border border-slate-200/80 max-w-full overflow-x-auto">
      {REVIEW_TABS.map((option) => {
        const active = option.key === tab;
        return (
          <button
            key={option.key}
            type="button"
            aria-pressed={active}
            onClick={() => onTabChange(option.key)}
            className={`inline-flex items-center gap-1 sm:gap-1.5 px-2.5 sm:px-3 py-1.5 rounded-lg text-xs font-bold whitespace-nowrap transition-all ${
              active ? 'bg-white text-[#008080] shadow-sm' : 'text-slate-600 hover:text-slate-900'
            }`}
          >
            <span className="sm:hidden">{option.shortLabel}</span>
            <span className="hidden sm:inline">{option.label}</span>
            <span className={`px-1.5 py-px rounded-full text-[10px] font-extrabold ${TAB_COUNT_TONES[option.key]}`}>{tabCounts[option.key]}</span>
          </button>
        );
      })}
    </div>

    <div role="group" aria-label="Filter by verdict" className="flex flex-wrap items-center gap-1.5">
      <span className="text-[11px] font-semibold text-slate-400 mr-0.5">Filter Verdict:</span>
      {VERDICT_BUCKETS.map((bucket) => {
        const active = bucket.key === verdict;
        const tones = VERDICT_TONES[bucket.key];
        return (
          <button
            key={bucket.key}
            type="button"
            aria-pressed={active}
            onClick={() => onVerdictChange(active ? 'all' : bucket.key)}
            className={`px-2.5 py-1 rounded-full border text-[11px] font-bold whitespace-nowrap transition-colors ${active ? tones.active : tones.idle}`}
          >
            {bucket.label} ({verdictCounts[bucket.key]})
          </button>
        );
      })}
    </div>
  </div>
);

export default ReviewControls;
